import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appOnlyenglish]'
})
export class OnlyenglishDirective {
  private regex = /^[^\u0600-\u06FF]*$/;

  @HostListener('input', ['$event'])
  onInputChange(event: InputEvent): void {
    const input = event.target as HTMLInputElement;
    const sanitizedValue = input.value.replace(/[\u0600-\u06FF]/g, ''); // Remove Arabic characters
    if (input.value !== sanitizedValue) {
      input.value = sanitizedValue;
      input.dispatchEvent(new Event('input')); // Trigger Angular's two-way binding
    }
  }
}
